import { removeTempBlock as removeTempBlockAction, setMoveStepLocationInTreeInactive } from '@/store/modules/treeBlocks/actions';
import { useStore } from '@/utils/store';

export const useTreeBlocksActions = () => {
	const { dispatch } = useStore();
	return {
		removeTempBlock: () => dispatch<null, void>(removeTempBlockAction, null),
		setMoveStepLocationInTreeInactive: () => dispatch<undefined, void>(setMoveStepLocationInTreeInactive, undefined),
	};
};
